import React, { Suspense } from 'react'
import {
    Route,
    Routes,
} from 'react-router-dom'

import NotFoundRoute from './shared/not-found-route'
import AppContainer from '../app/app-container'
import Login from '../components/auth/login'
import Logout from '../components/auth/Logout'
import {
    RequireAuth,
    RequireLogout,
    RequireSuperAdmin,
} from './shared/logged-route'
import SuperAdminUsersIndex from '../app/super-admin/users'
import SuperAdminUsersCompany from '../app/super-admin/users/company'
import IndexDevices from '../app/devices/list'
import LocationsIPDevices from '../app/devices/locations-ip'
import DeviceDetail from '../app/devices/detail/detail'
import DeviceHistory from '../app/devices/detail/history'
import DeviceOilLevelHistory from '../app/devices/detail/oil-level-history'
import UserProfile from '../app/user/profile'
import MapsIndex from '../app/maps/index'
import ForgottenPassword from '../components/auth/forgotten-password'

/**
 * Top-level application route table.
 *
 * Uses React Router 7 hooks-based API. Authentication guards are
 * expressed by wrapping the route element with `RequireAuth`,
 * `RequireSuperAdmin` or `RequireLogout`.
 */
const GlobalRoutes = () => (
    <Suspense fallback={<span />}>
        <Routes>
            <Route
                path="/"
                element={(
                    <RequireAuth>
                        <AppContainer><MapsIndex /></AppContainer>
                    </RequireAuth>
                )}
            />
            <Route
                path="/admin/users"
                element={(
                    <RequireSuperAdmin>
                        <AppContainer><SuperAdminUsersIndex /></AppContainer>
                    </RequireSuperAdmin>
                )}
            />
            <Route
                path="/admin/users/companies"
                element={(
                    <RequireSuperAdmin>
                        <AppContainer><SuperAdminUsersCompany /></AppContainer>
                    </RequireSuperAdmin>
                )}
            />
            <Route
                path="/maps"
                element={(
                    <RequireAuth>
                        <AppContainer><MapsIndex /></AppContainer>
                    </RequireAuth>
                )}
            />
            <Route
                path="/devices"
                element={(
                    <RequireAuth>
                        <AppContainer><IndexDevices filterMonitored={true} /></AppContainer>
                    </RequireAuth>
                )}
            />
            <Route
                path="/devices/not-monitored"
                element={(
                    <RequireAuth>
                        <AppContainer><IndexDevices filterMonitored={false} /></AppContainer>
                    </RequireAuth>
                )}
            />
            <Route
                path="/devices/all"
                element={(
                    <RequireAuth>
                        <AppContainer><IndexDevices filterMonitored={null} /></AppContainer>
                    </RequireAuth>
                )}
            />
            <Route
                path="/devices/locations-ip"
                element={(
                    <RequireSuperAdmin>
                        <AppContainer><LocationsIPDevices /></AppContainer>
                    </RequireSuperAdmin>
                )}
            />
            <Route
                path="/devices/:deviceUid"
                element={(
                    <RequireAuth>
                        <AppContainer><DeviceDetail /></AppContainer>
                    </RequireAuth>
                )}
            />
            <Route
                path="/devices/:deviceUid/history"
                element={(
                    <RequireAuth>
                        <AppContainer><DeviceHistory /></AppContainer>
                    </RequireAuth>
                )}
            />
            <Route
                path="/devices/:deviceUid/oil-history"
                element={(
                    <RequireAuth>
                        <AppContainer><DeviceOilLevelHistory /></AppContainer>
                    </RequireAuth>
                )}
            />
            <Route
                path="/user/profile"
                element={(
                    <RequireAuth>
                        <AppContainer><UserProfile /></AppContainer>
                    </RequireAuth>
                )}
            />

            <Route path="/login" element={<Login loginRedirect="/" />} />
            <Route path="/forgotten-password" element={<ForgottenPassword />} />
            <Route path="/first-login" element={<ForgottenPassword boxTitle="auth.firstLogin" />} />
            <Route
                path="/logout"
                element={(
                    <RequireLogout>
                        <Logout />
                    </RequireLogout>
                )}
            />

            <Route path="*" element={<NotFoundRoute routesType="globalRoutes" />} />
        </Routes>
    </Suspense>
)

export default GlobalRoutes
